/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

class UserSession
{
  sessionIdSS = 'objVault.userSessionData.sessionId';
  sessionInfo = null;

  constructor()
  {
    this.getSessionInfo = this.getSessionInfo.bind(this);
    this.removeUserSessionData = this.removeUserSessionData.bind(this);
  }

  getObjectSharingPermissions(grantedPermissions)
  {
    let permissions = [];
    permissions.push({permission: 'Not Shared', permissionClass: 'Share Objects'});

    for (let x = 0; x < grantedPermissions.length; x++)
      if ('Share Objects' === grantedPermissions[x].permissionClass) 
        permissions.push(grantedPermissions[x]);

    return permissions;
  }

  getSessionId()
  {
    let sessionId = sessionStorage.getItem(this.sessionIdSS);
    if ('undefined' === sessionId || undefined === sessionId ) sessionId = null;

    return sessionId;
  }

  async getSessionInfo(dbTwig)
  {
    let result = await dbTwig.callRestAPI('icam', 'getSessionInfo');
    if ('success' !== result.status) return dbTwig.apiErrorHandler(result, 'Error retrieving session info');
    this.sessionInfo = result.jsonData;
    return result.jsonData;
  }

  isAdministrator()
  {
    if (null == this.sessionInfo) return null;
    return (this.sessionInfo.accountType === 'administrator' ? true : false);
  }

  removeUserSessionData()
  {
    sessionStorage.removeItem(this.sessionIdSS);
    this.sessionInfo = {sessionStatus: 'no session'};
  }

  saveUserSessionData(userSessionData)
  {
    this.sessionInfo = userSessionData;
    sessionStorage.setItem(this.sessionIdSS, userSessionData.sessionId);
  }

  setSessionStatus(sessionStatus)
  {
    this.sessionInfo.sessionStatus = sessionStatus;
  }

  shareObjectsEnabled(grantedPermissions)
  {
    if (undefined === grantedPermissions || null === grantedPermissions) return false;
    
    for (let x = 0; x < grantedPermissions.length; x++)
    {
      if ('Share Objects' === grantedPermissions[x].permissionClass) return true;
    }

    return false;
  }

  viewSharedObjectsGranted(grantedPermissions)
  {
    if (null === grantedPermissions) return false;
    
    for (let x = 0; x < grantedPermissions.length; x++)
    {
      if ('View Shared Objects' === grantedPermissions[x].permission) return true;
    }

    return false;
  }
}

export default UserSession